<script>
	import { user } from '../stores';

	// See: https://stackoverflow.com/a/1527820/3403247
	/**
	 * Returns a random integer between min (inclusive) and max (inclusive).
	 * The value is no lower than min (or the next integer greater than min
	 * if min isn't an integer) and no greater than max (or the next integer
	 * lower than max if max isn't an integer).
	 * Using Math.round() will give you a non-uniform distribution!
	 */
	function getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	const greetings = ['Hello', 'Hey there', 'Howdy', 'Hiya', '\'Sup'];
	// TODO: only change this on leaving/returning to page (if user didn't hit "back")
	const greeting = greetings[getRandomInt(0, greetings.length-1)];

	// let username;
	// let discriminator;
	// $: if ($user) {
	// 	[ username, discriminator ] = $user.displayName.split('#');
	// }
</script>

<style>
	.user::selection, .user span::selection {
		background-color: #FF4136;
	}
	.user span {
		/* filter: brightness(400%); */
		color: #cfcfcf;
		font-size: 0.8em;
	}
</style>

<h1>{greeting},
	{#if $user}
	<span class="user">{$user.displayName}<span>#{$user.discriminator}</span></span>
	{:else}
	stranger
	{/if}
</h1>